export default "__VITE_ASSET__DzSD3anX__"